module.exports = __webpack_public_path__ + "media/images/flags/4x3/sur-5a345f8ebba96e1eabfc39adaa221801.svg";